import React, { Component } from "react";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import img1 from "../res/purchase_complete.png";
import img2 from "../res/googleplay.png";
import img3 from "../res/appstore.png";

class Paid extends Component {
  render() {
    return (
      <div id="login" className="noheader">
        <img src={img1} />
        <h1
          style={{
            fontFamily: "Arial",
            fontWeight: 700,
            fontSize: 16,
            lineHeight: "30px",
            color: "#4F4F4F",
            marginTop: "30px",
          }}
        >
          Beställningen är färdig
        </h1>
        {this.props.isLunda ? (
          <p
            style={{
              fontFamily: "Arial",
              fontWeight: 700,
              fontSize: 16,
              lineHeight: "24px",
              color: "#828282",
              maxWidth: "400px",
              margin: "20px auto 5px",
            }}
          >
            Nu är ditt konto aktiverat. Ladda ned Lundarundan appen i App Store
            eller Google Play. Om ditt konto inte aktiveras direkt, testa att
            starta om appen.
            <br />
            <br />
            Lycka till ute på lundarundan!
          </p>
        ) : (
          <p
            style={{
              fontFamily: "Arial",
              fontWeight: 700,
              fontSize: 16,
              lineHeight: "24px",
              color: "#828282",
              maxWidth: "400px",
              margin: "20px auto 5px",
            }}
          >
            Nu är ditt konto aktiverat. Ladda ned Bränteverest appen i App Store
            eller Google Play. Om ditt konto inte aktiveras direkt, testa att
            starta om appen.
            <br />
            <br />
            Lycka till ute på berget!
          </p>
        )}

        {this.props.isLunda ? (
          <>
            <a
              href="https://play.google.com/store/apps/details?id=com.korpenumea.lundarundan"
              target="_blank"
              style={{ marginTop: "30px" }}
            >
              {/*<img src="img/googleplay.png" alt="Google Play Store" />*/}
              <img src={img2} alt="Google Play Store" style={{ margin: 0 }} />
            </a>
            <a
              href="https://apps.apple.com/se/app/lundarundan/id1570044342"
              target="_blank"
              style={{ marginTop: "10px" }}
            >
              <img src={img3} alt="Apple app store" style={{ margin: 0 }} />
            </a>

            <button
              style={{ marginTop: "40px" }}
              onClick={() => (window.location.href = "https://branteverest.se")}
            >
              <p>Tillbaka</p>
            </button>
          </>
        ) : (
          <>
            <a
              href="https://play.google.com/store/apps/details?id=com.korpenumea.branteverest"
              target="_blank"
              style={{ marginTop: "30px" }}
            >
              {/*<img src="img/googleplay.png" alt="Google Play Store" />*/}
              <img src={img2} alt="Google Play Store" style={{ margin: 0 }} />
            </a>
            <a
              href="https://apps.apple.com/se/app/branteverest/id1564011731"
              target="_blank"
              style={{ marginTop: "10px" }}
            >
              <img src={img3} alt="Apple app store" style={{ margin: 0 }} />
            </a>

            <button
              style={{ marginTop: "40px" }}
              onClick={() => (window.location.href = "https://branteverest.se")}
            >
              <p>Tillbaka</p>
            </button>
          </>
        )}
      </div>
    );
  }
}

export default Paid;
